import { canv } from "@/canv/global.js";
import type { textWidget } from "@/elements/text/text";
import { Shape } from "../shape";

export class ShapeArrowRight extends Shape {
    width = 200;
    height = 182;

    fitText(
        textPart: textWidget,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = (width * 2) / 3 - 2 * horizontalPadding;
        const allowedHeight = height / 2 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        textPart.updateDims();

        textPart.startX = x + (width * 3) / 4 / 2 - textPart.width / 2;
        textPart.startY = y + textPart.lines[0].textHeight + height / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + height / 4);
        canv.ctx.lineTo(x + (width * 2) / 3, y + height / 4);
        canv.ctx.lineTo(x + (width * 2) / 3, y);
        canv.ctx.lineTo(x + width, y + height / 2);
        canv.ctx.lineTo(x + (width * 2) / 3, y + height);
        canv.ctx.lineTo(x + (width * 2) / 3, y + (height * 3) / 4);
        canv.ctx.lineTo(x, y + (height * 3) / 4);
        canv.ctx.lineTo(x, y + height / 4);
        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="${fill}" stroke="${stroke}" d="M11.5 2.22684V4.5C11.5 5.05228 11.0523 5.5 10.5 5.5H2C1.44772 5.5 1 5.94772 1 6.5V17.5C1 18.0523 1.44772 18.5 2 18.5H10.5C11.0523 18.5 11.5 18.9477 11.5 19.5V21.7732C11.5 22.636 12.5195 23.0938 13.1644 22.5206L24.1592 12.7474C24.6067 12.3496 24.6067 11.6504 24.1592 11.2526L13.1644 1.47943C12.5195 0.906189 11.5 1.364 11.5 2.22684Z"/>
            </svg>
        `;
    }
}
